export default __webpack_public_path__ + "static/media/1968.909ed846.png";